export const checkInPermission = (needs?: string[], have?: string[], and: boolean = false) => {
  if (!have?.length) {
    return false;
  }
  return !needs?.length || needs[0] === '*' || (and
    ? needs.every(need => have.includes(need))
    : needs.some(need => have.includes(need)));
};
